import { z } from 'zod';

import { BorrowerId } from '../../../BrandedIds';
import { RepaymentWorkoutPlan } from '../../../loan/WorkoutPlan';
import { zodBrandedUuid } from '../../../utils/Zod';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CreateRepaymentWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('createRepaymentWorkoutPlan'),
  data: RepaymentWorkoutPlan.pick({
    startDate: true,
    startStatementDate: true,
    endStatementDate: true,
    termMonths: true,
    hasFees: true,
    workflowInformation: true,
  }).extend({
    sendAgreementTo: z.array(zodBrandedUuid<BorrowerId>()),
    quotedMonthlyPaymentAmount: z.number().nonnegative(),
  }),
});
export type CreateRepaymentWorkoutPlanEvent = z.infer<typeof CreateRepaymentWorkoutPlanEvent>;
